import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PendingVerification = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Typography variant="h5">
        We have received your registration , our Account Verification Team ,
        will contact and Approve your profile. After verification done, we will
        send you email , then you can login to the system.{" "}
      </Typography>

      <Button variant="contained" sx={{ mt: 3 }} onClick={() => navigate("/")}>
        Back to home
      </Button>
    </Box>
  );
};

export default PendingVerification;
